import { Link } from "react-router-dom";

/**
 * CREATE's entry point: two clearly separate paths, always both shown to
 * every authorized product user (neither is hidden by plan or by a feature
 * flag — a user's ROLE decides which Image actions are enabled later, not
 * whether Image Mode exists for them).
 *
 * Owner t1158u / t1164u: every entry is one compact single-line button with a 2-3 word label (no long description), so all six are visible
 * without scrolling on a phone (390x844) and on desktop. Targets and test ids are unchanged. Owner t1166u: VIDEO (the RP flow: Deep Research / Reel
 * "Repurpose (RP)" hand-offs open /generate/create/video) is "RP repurpose", RE is "RE reverse eng.", RE moved up next to RP (first row);
 * t1167u: the two search entries (Reel research, Deep research) share the second row, Image set + Telegram posts the third.
 */
export function CreateEntry() {
  return (
    <div>
      <h2>Create</h2>
      <p className="muted">Choose what you want to create.</p>
      <div className="grid grid-2 mode-cards">
        <Link to="/generate/create/video" className="card mode-card" data-testid="create-choose-video">
          <h3>RP repurpose</h3>
          <span className="mode-card-cta" aria-hidden="true">→</span>
        </Link>
        <Link to="/generate/create/re" className="card mode-card" data-testid="create-choose-re">
          <h3>RE reverse eng.</h3>
          <span className="mode-card-cta" aria-hidden="true">→</span>
        </Link>
        <Link to="/generate/create/reel" className="card mode-card" data-testid="create-choose-reel">
          <h3>Reel research</h3>
          <span className="mode-card-cta" aria-hidden="true">→</span>
        </Link>
        <Link to="/generate/create/deep-research" className="card mode-card" data-testid="create-choose-deep-research">
          <h3>Deep research</h3>
          <span className="mode-card-cta" aria-hidden="true">→</span>
        </Link>
        <Link to="/generate/create/image" className="card mode-card" data-testid="create-choose-image">
          <h3>Image set</h3>
          <span className="mode-card-cta" aria-hidden="true">→</span>
        </Link>
        <Link to="/generate/create/image/telegram" className="card mode-card" data-testid="create-choose-telegram">
          <h3>Telegram posts</h3>
          <span className="mode-card-cta" aria-hidden="true">→</span>
        </Link>
      </div>
    </div>
  );
}
